export default __webpack_public_path__ + "static/media/logo-short.dae905b9.svg";